import axios from 'axios'
import axiosInstance from '../helpers/axiosInstance'

export const login = async (email, password) => {
  const res = await axios.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/login`, { email, password }, { withCredentials: true })
  return res.data
}

// Identifier-first SSO discovery: tells the login form whether to redirect to
// Google SSO or show a password field. Unauthenticated; no credentials needed.
export const getLoginMethod = async email => {
  const res = await axios.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/auth/methods`, { params: { email } })
  return res.data.method // "sso" | "password"
}

export const getUser = async () => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/user`)
  return res.data
}
